import Vue from 'vue';
import Vuex from 'vuex';

import localStore from './modules/localStore';
import familyStore from './modules/familyStore';
import teamStore from './modules/teamStore';
import childStore from './modules/childStore';
import usersStore from './modules/usersStore';
import dataStore from './modules/dataStore';
import categoryStore from './modules/categoryStore';
import dataTypeStore from './modules/dataTypeStore';
import settingsStore from './modules/settingsStore';
import documentStore from './modules/documentStore';
import notificationStore from './modules/notificationStore';
import roleStore from './modules/roleStore';
import tagsStore from './modules/tagsStore';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		localStore,
		familyStore,
		teamStore,
		childStore,
		usersStore,
		dataStore,
		categoryStore,
		dataTypeStore,
		settingsStore,
		documentStore,
		notificationStore,
		roleStore,
		tagsStore
	}
});

export default store;
